import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Protocolo Anti-Friendzone',
    value: '$27'
  }, {
    title: 'Mini Manual Anti-Ansiedad',
    value: '$27'
  }, {
    title: 'Los 12 Errores que Matan la Atracción',
    value: '$17'
  }];
  return <section className="py-20 px-4 bg-gradient-to-b from-brand-dark to-black border-y border-brand-gold/20" data-id="element-16">
      <div className="container mx-auto max-w-4xl" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-18">
          <span className="text-brand-gold font-bold tracking-widest uppercase mb-2 block" data-id="element-19">
            Solo por hoy
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white" data-id="element-20">
            BONOS EXCLUSIVOS <span className="text-brand-gold" data-id="element-21">GRATIS</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-22">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-black border border-brand-gold/30 p-6 rounded-lg text-center relative overflow-hidden group" data-id="element-23">
              <div className="absolute top-0 right-0 bg-brand-gold text-black text-xs font-bold px-2 py-1" data-id="element-24">
                GRATIS
              </div>
              <Gift className="w-12 h-12 text-brand-gold mx-auto mb-4 group-hover:scale-110 transition-transform" data-id="element-25" />
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-26">
                {bonus.title}
              </h3>
              <p className="text-sm text-gray-400" data-id="element-27">
                Valor: <span className="line-through" data-id="element-28">{bonus.value}</span>
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-12 p-6 bg-brand-gold/10 border border-brand-gold/30 rounded-lg text-center max-w-lg mx-auto" data-id="element-29">
          <p className="text-gray-300 uppercase tracking-widest text-sm mb-2" data-id="element-30">
            Valor Total de Bonos
          </p>
          <p className="text-4xl font-bold text-brand-gold line-through decoration-brand-red decoration-4" data-id="element-31">
            $71 USD
          </p>
          <p className="text-white font-bold mt-2" data-id="element-32">
            HOY: $0 (Incluido con tu orden)
          </p>
        </motion.div>
      </div>
    </section>;
}